<template>
  <!--
   Was previously done using DialogProgrammatic APIs in AlertService,
   but this API is no longer available in Buefy Next.

   Correct way to show dialog remains through AlertService APIs.
   -->
  <b-dialog
    v-if="isActive"
    id="openadom-dialog"
    can-cancel
    v-bind="dialogData"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <div class="card-content">
      <p v-html="dialogData.message" />
    </div>

    <!--If prompt, show input from inputAttrs -->
    <b-input
      v-if="dialogData.inputAttrs"
      ref="promptInput"
      v-model="promptInputValue"
      expanded
      v-bind="dialogData.inputAttrs || {}"
    />
  </b-dialog>
</template>

<script lang="ts">
import { ref, onMounted } from "vue";
import { BInput } from "buefy";

export default {
  name: "DialogService",
  components: { BInput },
  setup() {
    const isActive = ref(false);
    const dialogData = ref({});
    const promptInputValue = ref("");
    const autoCloseTimeout = ref(null);

    const clearAutoCloseTimer = () => {
      if (autoCloseTimeout.value) {
        clearTimeout(autoCloseTimeout.value);
        autoCloseTimeout.value = null;
      }
    };

    const showDialog = (dialogParams) => {
      if (autoCloseTimeout.value) {
        clearTimeout(autoCloseTimeout.value);
        autoCloseTimeout.value = null;
      }
      // Make sur to delete confirm and cancel callback to use our own
      dialogParams.onConfirmWithoutHiding = dialogParams.onConfirm;
      dialogParams.onCancelWithoutHiding = dialogParams.onCancel;
      delete dialogParams.onConfirm;
      delete dialogParams.onCancel;
      promptInputValue.value = dialogParams.inputValue || "";
      dialogData.value = dialogParams;
      isActive.value = true;
      // Si autoCloseAfter est défini, programme la fermeture automatique
      if (dialogParams.autoCloseAfter) {
        autoCloseTimeout.value = setTimeout(() => {
          isActive.value = false;
          // Optionnel : déclencher onCancelWithoutHiding ou autre callback ici
          if (dialogParams.onCancelWithoutHiding) {
            dialogParams.onCancelWithoutHiding();
          }
        }, dialogParams.autoCloseAfter);
      }
    };

    const onConfirm = () => {
      clearAutoCloseTimer();
      isActive.value = false;
      let value = promptInputValue.value ?? "";
      if (dialogData.value.onConfirmWithoutHiding) {
        dialogData.value.onConfirmWithoutHiding(value);
      }
    };

    const onCancel = () => {
      clearAutoCloseTimer();
      isActive.value = false;
      if (dialogData.value.onCancelWithoutHiding) {
        dialogData.value.onCancelWithoutHiding();
      }
    };

    onMounted(async () => {
      document.addEventListener("show-dialog", (event) => {
        showDialog(event.detail);
      });
    });

    return {
      showDialog,
      isActive,
      dialogData,
      onConfirm,
      onCancel,
      promptInputValue,
    };
  },
};
</script>
